/* ── Studio Phalsa — Individual Product Page JS ─────────────── */

(function () {
  'use strict';

  const data = window.spProductData;
  if (!data) return;

  /* ── State ─────────────────────────────────────────────────── */
  let selectedColour = null;
  let selectedSize   = null;
  let currentVariant = data.variants.find(v => v.id === data.currentVariantId) || data.variants[0];
  let currentCart    = null;

  /* ── Helpers ───────────────────────────────────────────────── */
  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.from((root || document).querySelectorAll(selector));
  }

  function formatMoney(cents) {
    const amount = cents / 100;
    return '₹' + amount.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function findVariant(colour, size) {
    return data.variants.find(v => {
      const matchColour = colour ? v['option' + (data.colorOptionIndex + 1)] === colour : true;
      const matchSize   = size   ? v['option' + (data.sizeOptionIndex  + 1)] === size   : true;
      return matchColour && matchSize;
    }) || null;
  }

  function updateURL(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState({}, '', url);
  }

  /* ── Initialise selected state from current variant ────────── */
  function initState() {
    if (currentVariant) {
      selectedColour = currentVariant['option' + (data.colorOptionIndex + 1)] || null;
      selectedSize   = currentVariant['option' + (data.sizeOptionIndex  + 1)] || null;
    }
  }

  /* ── Variant update ─────────────────────────────────────────── */
  function applyVariant(variant) {
    if (!variant) return;
    currentVariant = variant;

    // Price
    const priceEl = $('[data-sp-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Variant ID in form
    const idInput = $('[data-sp-variant-id]');
    if (idInput) idInput.value = variant.id;

    // Buy it Now href
    const buyBtn = $('[data-sp-buy-now]');
    if (buyBtn) {
      buyBtn.href = `/cart/${variant.id}:1`;
    }

    // Add to cart button state
    const addBtn   = $('[data-sp-add-btn]');
    const addLabel = $('[data-sp-add-label]');
    if (addBtn && addLabel) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addLabel.textContent = 'ADD TO CART';
      } else {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addLabel.textContent = 'SOLD OUT';
      }
    }

    updateURL(variant.id);
  }

  /* ── Colour switching ───────────────────────────────────────── */
  function initColourThumbs() {
    const thumbs = $$('[data-colour]');
    if (!thumbs.length) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const colour = thumb.dataset.colour;
        if (colour === selectedColour) return;
        selectedColour = colour;

        // Update selected thumb
        thumbs.forEach(t => t.classList.remove('is-selected'));
        thumb.classList.add('is-selected');

        // Update colour label
        const nameEl = $('[data-sp-colour-name]');
        if (nameEl) nameEl.textContent = colour;

        // Fade grid to this colour's images
        switchColourImages(colour);

        // Update size availability for new colour, keep current size selection if valid
        updateSizeAvailability(colour);

        // Find new variant
        const v = findVariant(colour, selectedSize);
        if (v) applyVariant(v);
      });
    });
  }

  
  // old code commented
  function getImagesForColour(colour) {
    // Method 1: images attached to variant
    const variant = data.variants.find(v =>
      v.option1 === colour || v.option2 === colour
    );

    let variantImages = [];
    if (variant) {
      variantImages = data.images.filter(img =>
        img.variantIds &&
        img.variantIds.includes(variant.id)
      );
    }
  // old code ends

    // Method 2: fallback — match by alt text (exact, not substring —
    // .includes() risked false positives, e.g. a "White" colour matching
    // "Off White" alt text)
    const colourLower = colour.toLowerCase().trim();
    const altImages = data.images.filter(img =>
      img.alt &&
      img.alt.toLowerCase().trim() === colourLower
    );

    // Merchants don't always tag every colour photo against every variant
    // (variantIds can be sparse for a given size), so Method 1 can under-count.
    // Alt-text matching reflects "all photos of this colour," which is what a
    // colour swatch switch should show — prefer whichever method finds more.
    if (altImages.length > variantImages.length) return altImages;
    if (variantImages.length > 0) return variantImages;
    if (altImages.length > 0) return altImages;

    // Method 3: fallback — variant featured image only
    if (variant && variant.featured_image) {
      return [variant.featured_image];
    }

    return [];
  }

  // This product's own tallest colour, in image count — computed once from
  // spProductData (not a guessed constant) so the desktop grid can reserve
  // exactly as much height as this product ever needs, no more.
  let maxImagesPerColourCache = null;
  function getMaxImagesPerColour() {
    if (maxImagesPerColourCache !== null) return maxImagesPerColourCache;
    const key     = 'option' + (data.colorOptionIndex + 1);
    const colours = [...new Set(data.variants.map(v => v[key]).filter(Boolean))];
    maxImagesPerColourCache = colours.reduce(
      (max, c) => Math.max(max, getImagesForColour(c).length),
      0
    );
    return maxImagesPerColourCache;
  }

  function switchColourImages(colour) {
  const variantImages = getImagesForColour(colour);
  if (variantImages.length === 0) return;

  const gridItems     = $$('.sp-product__grid-item');
  const gridImgs = $$('.sp-product__grid-img:not(video)');
  const maxImages     = getMaxImagesPerColour();
  const isDesktop     = window.matchMedia('(min-width: 901px)').matches;
  let realSlotHeight  = null;

  gridItems.forEach((item, i) => {
    const img         = gridImgs[i];
    const isVideoSlot = item.querySelector('video') !== null;

    if (isVideoSlot) {
      // Video slots: show only if the video's colour matches the selected colour
      const videoWrapper = item.querySelector('.sp-product__grid-video');
      const videoColour  = videoWrapper ? videoWrapper.dataset.videoColour : '';
      if (videoColour === colour) {
        item.style.display    = '';
        item.style.flex       = '0 0 100%';
        item.style.minWidth   = '100%';
        item.style.visibility = 'visible';
        item.style.overflow   = '';
        item.style.width      = '';
        item.style.maxWidth   = '';
        item.style.padding    = '';
        item.style.margin     = '';
        item.style.height     = '';
        item.style.minHeight  = '';
      } else {
        item.style.display    = 'none';
        item.style.flex       = '0 0 0px';
        item.style.minWidth   = '0';
        item.style.width      = '0';
        item.style.maxWidth   = '0';
        item.style.overflow   = 'hidden';
        item.style.visibility = 'hidden';
        item.style.padding    = '0';
        item.style.margin     = '0';
      }
      return; // skip image logic for video slots
    }

    if (i < variantImages.length) {
      item.style.display    = '';
      item.style.flex       = '0 0 100%';
      item.style.minWidth   = '100%';
      item.style.visibility = 'visible';
      item.style.overflow   = '';
      item.style.width      = '';
      item.style.maxWidth   = '';
      item.style.padding    = '';
      item.style.margin     = '';
      item.style.height     = '';
      item.style.minHeight  = '';

      if (img) {
        img.style.display = '';
        img.classList.add('is-fading');
        setTimeout(() => {
          let newSrc = variantImages[i].src;
          if (newSrc && newSrc.startsWith('//')) newSrc = 'https:' + newSrc;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = newSrc;
          img.alt = variantImages[i].alt || '';
          img.classList.remove('is-fading');
        }, 200);
      }
    } else {
      item.style.display    = 'none';
      item.style.flex       = '0 0 0px';
      item.style.minWidth   = '0';
      item.style.width      = '0';
      item.style.maxWidth   = '0';
      item.style.overflow   = 'hidden';
      item.style.visibility = 'hidden';
      item.style.padding    = '0';
      item.style.margin     = '0';
    }
  });

  // Keep mobile dot indicators in sync
  const dots = $$('.sp-product__image-dot');
  dots.forEach((dot, i) => {
    dot.style.display = i < variantImages.length ? '' : 'none';
    dot.classList.toggle('is-active', i === 0);
  });

  const grid = $('.sp-product__image-grid');
  if (grid) grid.scrollTo({ left: 0, behavior: 'instant' });
}



  /* ── Size selection ─────────────────────────────────────────── */
  function initSizeBtns() {
    const sizeBtns = $$('[data-size]');
    if (!sizeBtns.length) return;

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const size = btn.dataset.size;
        selectedSize = size;

        // Update selected button
        sizeBtns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        // Update size label
        const nameEl = $('[data-sp-size-name]');
        if (nameEl) nameEl.textContent = size;

        // Find matching variant
        const v = findVariant(selectedColour, size);
        if (v) applyVariant(v);
      });
    });
  }

  function updateSizeAvailability(colour) {
    const sizeBtns = $$('[data-size]');
    sizeBtns.forEach(btn => {
      const size = btn.dataset.size;
      const v    = findVariant(colour, size);
      if (v && !v.available) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  /* ── Accordion ──────────────────────────────────────────────── */
  function initAccordions() {
    const accordions = $$('[data-sp-accordion]');
    accordions.forEach(accordion => {
      const trigger = accordion.querySelector('[data-sp-accordion-trigger]');
      const body    = accordion.querySelector('[data-sp-accordion-body]');
      if (!trigger || !body) return;

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeAllAccordions(accordions);

        if (!isOpen) {
          openAccordion(trigger, body);
        }
      });
    });
  }

  function openAccordion(trigger, body) {
    trigger.setAttribute('aria-expanded', 'true');
    const content = body.firstElementChild;
    const height  = content ? content.scrollHeight : 0;
    body.style.height = height + 'px';
    // After transition, let height be auto so content reflows don't clip
    body.addEventListener('transitionend', function onEnd() {
      body.style.height = 'auto';
      body.removeEventListener('transitionend', onEnd);
    }, { once: true });
  }

  function closeAccordion(trigger, body) {
    // Lock to pixel height before animating to 0
    body.style.height = body.scrollHeight + 'px';
    // Force reflow
    body.offsetHeight; // eslint-disable-line no-unused-expressions
    trigger.setAttribute('aria-expanded', 'false');
    body.style.height = '0';
  }

  function closeAllAccordions(accordions) {
    accordions.forEach(acc => {
      const t = acc.querySelector('[data-sp-accordion-trigger]');
      const b = acc.querySelector('[data-sp-accordion-body]');
      if (t && b && t.getAttribute('aria-expanded') === 'true') {
        closeAccordion(t, b);
      }
    });
  }

  /* ── Add to cart ────────────────────────────────────────────── */
  function initAddToCart() {
    const form   = $('[data-sp-form]');
    const addBtn = $('[data-sp-add-btn]');
    if (!form || !addBtn) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variantId = $('[data-sp-variant-id]')?.value;
      if (!variantId) return;

      const variant = data.variants.find((v) => v.id === Number(variantId));
      if (variant && variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
        await ensureCartCache();
        const currentQty = getCartQuantityForVariant(Number(variantId));
        if (currentQty + 1 > variant.inventory_quantity) {
          if (label) {
            label.textContent = 'Max quantity reached';
          }
          setTimeout(() => {
            if (label) label.textContent = prevLabel;
          }, 2000);
          return;
        }
      }

      addBtn.classList.add('is-loading');
      const label = $('[data-sp-add-label]');
      const prevLabel = label?.textContent || 'ADD TO CART';
      if (label) label.textContent = 'Adding…';

      try {
        const res  = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add to cart.');
        }

        if (label) label.textContent = 'Added!';

        // Fetch the fresh cart and dispatch Horizon's cart:update event
        // BEFORE opening the drawer — component-cart-items.js listens for
        // this and re-renders its own section (it has no other way to
        // know the cart changed; cart-drawer-component only toggles the
        // dialog open/closed, it doesn't touch cart contents itself).
        await refreshCart();

        // Open the custom cart panel
        if (window.spCartPanel) {
          window.spCartPanel.open();
        }

      } catch (err) {
        console.error('[SP] Add to cart error:', err);
        if (label) label.textContent = 'Try again';
      } finally {
        addBtn.classList.remove('is-loading');
        setTimeout(() => {
          if (label) label.textContent = prevLabel;
        }, 2000);
      }
    });
  }

  function openCartDrawer() {
    // Horizon cart drawer: click the cart trigger button in the navbar
    const cartBtn = document.querySelector('.sp-navbar__cart-btn');
    if (cartBtn) {
      cartBtn.click();
      return;
    }
    // Fallback: try the web component's open method
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  function getCartQuantityForVariant(variantId) {
    if (!currentCart?.items) return 0;
    const item = currentCart.items.find((cartItem) => Number(cartItem.variant_id) === Number(variantId));
    return item ? item.quantity : 0;
  }

  async function ensureCartCache() {
    if (currentCart) return currentCart;
    await refreshCart();
    return currentCart;
  }

  async function refreshCart() {
    try {
      const res  = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      currentCart = cart;

      const badge = document.querySelector('.sp-navbar__cart-badge');
      if (badge) badge.textContent = cart.item_count;

      // Same event name as CartAddEvent/CartUpdateEvent in @theme/events
      // ('cart:update') — component-cart-items.js listens on document for
      // this and self-refreshes via sectionRenderer since we don't have
      // rendered `sections` HTML to hand it (that's only available from
      // Horizon's own product-form-component flow).
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: { itemCount: cart.item_count }
        }
      }));
    } catch (_) { /* silent */ }
  }

  /* ── Navbar: always solid on product page ────────────────────── */
  function initNavbar() {
    const navbar = document.querySelector('.sp-navbar');
    if (!navbar) return;

    // Force solid immediately (product page has no hero behind navbar)
    navbar.classList.add('is-scrolled');

    // Keep it solid — override the global scroll handler by re-adding on scroll
    window.addEventListener('scroll', () => {
      if (!navbar.classList.contains('is-scrolled')) {
        navbar.classList.add('is-scrolled');
      }
    }, { passive: true });
  }

  /* ── Product recommendations ─────────────────────────────────── */
  async function initRecommendations() {
    const container = $('#sp-product-recommendations');
    if (!container) return;

    const productId = container.dataset.productId;
    const limit     = container.dataset.limit || 3;
    const grid      = container.querySelector('[data-sp-rec-grid]');
    if (!grid) return;

    try {
      const res  = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`);
      const json = await res.json();
      const products = json.products;

      if (!products || !products.length) {
        container.style.display = 'none';
        return;
      }

      grid.innerHTML = products.map(renderProductCard).join('');

      // Observe cards for scroll reveal
      observeCards(grid);

    } catch (err) {
      console.error('[SP] Recommendations error:', err);
      container.style.display = 'none';
    }
  }

  function renderProductCard(product) {
    const url       = product.url;
    const title     = escapeHtml(product.title);
    const price     = formatMoney(product.price_min);
    const images    = product.images || [];
    const frontImg  = images[0];
    const backImg   = images[1] || images[0];

    const imgTag = (img, cls, loading) => {
      if (!img) return '';
      const src    = img.src || img;
      const alt    = escapeHtml(img.alt || product.title);
      const w800   = src.replace(/(\.[^.]+)$/, '_800x$1');
      const w1600  = src.replace(/(\.[^.]+)$/, '_1600x$1');
      return `<img
        class="${cls}"
        src="${src}"
        srcset="${w800} 800w, ${w1600} 1600w"
        sizes="(max-width: 600px) calc(50vw - 12px), 400px"
        alt="${alt}"
        loading="${loading}"
        draggable="false"
      >`;
    };

    return `
      <article class="sp-product-card" data-sp-rec-card>
        <a href="${url}" class="sp-product-card__image-wrap" aria-label="${title}">
          ${imgTag(frontImg, 'sp-product-card__front-img', 'lazy')}
          ${imgTag(backImg,  'sp-product-card__back-img',  'lazy')}
        </a>
        <div class="sp-product-card__info">
          <a href="${url}" class="sp-product-card__name">${title}</a>
          <span class="sp-product-card__price">${price}</span>
        </div>
      </article>
    `.trim();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Mobile slider: dot indicators ────────────────────────────
     Grid only scrolls horizontally at the ≤768px breakpoint (see
     sp-product.css) — dots are CSS-hidden above that, so this is
     harmless to always attach, same as the featured-products slider. */
  function initImageDots() {
    const grid = $('.sp-product__image-grid');
    const dots = $$('.sp-product__image-dot');
    if (!grid || !dots.length) return;

    grid.addEventListener('scroll', () => {
      const index = Math.round(grid.scrollLeft / grid.offsetWidth);
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }, { passive: true });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        grid.scrollTo({ left: i * grid.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  /* ── Scroll reveal ──────────────────────────────────────────── */
  function observeCards(root) {
    const cards = $$('.sp-product-card', root);
    if (!cards.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    cards.forEach(card => observer.observe(card));
  }

  /* ── Boot ───────────────────────────────────────────────────── */
  function init() {
    initState();
    initNavbar();
    initColourThumbs();

    const selectedThumb = $('.sp-product__colour-thumb.is-selected');
    if (selectedThumb && selectedThumb.dataset.colour) {
      switchColourImages(selectedThumb.dataset.colour);
    }

    initSizeBtns();
    initAccordions();
    initAddToCart();
    initRecommendations();
    initImageDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
